module.exports = __webpack_public_path__ + "img/boton Nuevamente.9fc9e793.svg";